// eslint-disable-next-line import/no-unresolved
import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import React from 'react';

import ConfigProvider from '../config/ConfigProvider';
import { Environment, Locale, PaymentMethod, ShopBundle } from '../types';

import useAuthorizationActionErrorLogger from './Adyen/Authorization/hooks/useErrorLogger';
import ShopCheckoutActionCreator from './Adyen/Authorization/ShopCheckoutActionCreator';
import I18nProvider from './I18nProvider';
import SentryErrorBoundary from './SentryErrorBoundary';
import '@adyen/adyen-web/dist/adyen.css';

export type PaymentAuthorizationActionProps = {
  shopBundle: ShopBundle;
  locale: Locale;
  paymentMethod: PaymentMethod;
  csrfToken: string;
  domain: string;
  paymentId: string;
  paymentAction: PaymentAction;
  env: Environment;
};

const PaymentAuthorizationAction: React.FC<PaymentAuthorizationActionProps> = (props) => {
  const { shopBundle, locale, paymentId, paymentMethod, env } = props;
  useAuthorizationActionErrorLogger({ paymentId, paymentMethod });

  return (
    <ConfigProvider env={env} shopBundle={shopBundle}>
      <I18nProvider shopBundle={shopBundle} locale={locale}>
        <SentryErrorBoundary>
          <ShopCheckoutActionCreator {...props} />
        </SentryErrorBoundary>
      </I18nProvider>
    </ConfigProvider>
  );
};

export default PaymentAuthorizationAction;
